import React from "react";
import { Route, Redirect } from "react-router-dom";
const VolunteerRoute = ({ component, isLoggedIn, canAccess, ...rest }) => {
  const Component = component;

  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn && canAccess ? (
          <Component {...props} />
        ) : (
          <Redirect to={"/login"} />
        )
      }
    />
  );
};

export default VolunteerRoute;
